<div class="vcard">
	<div class="furtherInformations">
		<small>
		  	<span *ngIf="publication.publicationType?.text">{{publication.publicationType.text}}</span>
		  	<span *ngIf="publication.documentType?.text"> | {{publication.documentType.text}}</span>
		  	<span *ngIf="publication.qualificationThesis?.text && NONE_QUALIFICATION_THESIS !== publication.qualificationThesis.id"> | {{publication.qualificationThesis.text}}</span>
		  	<span *ngIf="PEER_REVIEWED_HISKEY_ID === publication.peerReviewedProcess?.hiskeyId"> {{'fs.res.publication.view.peerReviewed' | hisUi}}</span>
		  	<ng-container *ngIf="publication.access && !(publication.accessAfterEmbargoDate && embargoDateReached())" [ngSwitch]="publication.access.hiskeyId">
		  		<span *ngSwitchCase="OPEN_ACCESS"> | {{publication.access.text}}</span>
		  	</ng-container>
            <ng-container *ngIf="publication.accessAfterEmbargoDate && embargoDateReached()" [ngSwitch]="publication.accessAfterEmbargoDate.hiskeyId">
                <span *ngSwitchCase="OPEN_ACCESS"> | {{publication.accessAfterEmbargoDate.text}}</span>
            </ng-container>
		  	<!-- #288149 Wer das Recht hat den Status zu bearbeiten, der soll diesen auch auf der Detailseite angezeigt bekommen -->
		  	<span *ngIf="publication.status?.defaulttext && auth.hasAny('RIGHT_FS_RES_PUBLICATION_EDIT_PUBLICATION_STATUS')"> | {{publication.status.defaulttext}}</span>
		</small>
	</div>
	<h1>
	    <his-translated-text [hisobject]="publication" hisAttribute="title"></his-translated-text>
	    <ng-container *ngIf="publication.subtitle"> : <his-translated-text [hisobject]="publication" hisAttribute="subtitle"></his-translated-text></ng-container>
    </h1>
	<div class="personAndOrganisation">
		<span *ngIf="publication.publicationCreatorType && isTypeOfEditor()">
			{{'fs.res.publication.Publication.editor.detailtext' | hisUi}}:
		</span>
		<span *ngIf="!isEmpty(publication.creators)">
			<!-- Only show first three creators of the publication -->
			<ng-container *ngIf="!showAllCreators">
				<ng-container *ngFor="let creator of publication.creators | slice:0:3; index as i, last as lastCreator">
					<ng-container *ngIf="showAsPerson(creator)">
						<!-- Check if role has rights to see details of person -->
						<a href="../cs.psv.frontend/person/view/{{creator.person.id}}?showBackButton=true"
								*ngIf="creator.person && creator.hasVisibleAffiliations; else rawtext"
								class="firstLink"
								(click)="onBeforeNavigate()"
								title="{{'fs.res.common.showProfileOf'|hisUi:(creator.firstname +' '+ creator.creatorname)}}">
							<strong>{{getCreatorFullName(creator)}}</strong>
						</a>
						<!-- Display no link when role doesn't have right -->
						<ng-template #rawtext><strong>{{getCreatorFullName(creator)}}</strong></ng-template>
					</ng-container>

					<span *ngIf="showAsOrganization(creator)">
						<!-- Check if creator is organization -->
						<ng-container *ngIf="creator.creatorOrganizations[0].organization.text === creator.creatorname; else assigned">
							<!-- todo: Check if role has rights to see details of organization -->
							<span>{{creator.creatorOrganizations[0].organization.text}}</span>
						</ng-container>
						<!-- Display when organization is assigned to person -->
						<ng-template #assigned>
							<!-- todo: Check if role has rights to see details of organization -->
							<span>&ngsp;({{getCreatorOrganizations(creator.creatorOrganizations)}})</span>
						</ng-template>
					</span>

					<span *ngIf="showAsExternalOrganization(creator)">
						<!-- Check if creator is external organization -->
						<ng-container *ngIf="creator.creatorOrganizations[0].researchPartner.defaulttext === creator.creatorname; else assigned">
							<!-- todo: Check if role has rights to see details of external organization -->
							<span>{{creator.creatorOrganizations[0].researchPartner.defaulttext}}</span>
						</ng-container>
						<!-- Display when external organization is assigned to person -->
						<ng-template #assigned>
							<!-- todo: Check if role has rights to see details of external organization -->
							<span>&ngsp;({{getCreatorOrganizations(creator.creatorOrganizations)}})</span>
						</ng-template>
					</span>

					<span *ngIf="showAsSomethingElse(creator)">
						<strong>{{getCreatorFullName(creator)}}</strong>
					</span>

					<!-- show only for the first three creators with comma, the rest is hidden by icon -->
					<span *ngIf="!lastCreator">, </span>
					<span *ngIf="2 === i && 3 < publication.creators.length"> {{'fs.res.publication.view.etal' | hisUi}}</span>
					<button *ngIf="2 === i && 3 < publication.creators.length" class="icon" (click)="showAllCreators = true">
					  	<img *ngIf="isTypeOfAuthor()" hisImage="ARROW_DOWN_V" class="inlineicon" title="{{ ('fs.res.publication.view.showAllAuthors' | hisUi) }}">
						<img *ngIf="isTypeOfEditor()" hisImage="ARROW_DOWN_V" class="inlineicon" title="{{ ('fs.res.publication.view.showAllEditors' | hisUi) }}">
					</button>
				</ng-container>
			</ng-container>

			<!-- Only displayed after clicking the et. al. symbol when more than three creators are assigned -->
			<ng-container *ngIf="showAllCreators">
				<ng-container *ngFor="let creator of publication.creators; index as i; last as lastCreator">

					<ng-container *ngIf="showAsPerson(creator)">
						<a href="../cs.psv.frontend/person/view/{{creator.person.id}}?showBackButton=true"
								*ngIf="creator.person && creator.hasVisibleAffiliations; else rawtext"
								class="firstLink"
                                (click)="onBeforeNavigate()"
								title="{{'fs.res.common.showProfileOf'|hisUi:(creator.firstname +' '+ creator.creatorname)}}">
						<strong>{{getCreatorFullName(creator)}}</strong></a>
						<ng-template #rawtext><strong>{{getCreatorFullName(creator)}}</strong></ng-template>
					</ng-container>

					<span *ngIf="showAsOrganization(creator)">
						<!-- Check if creator is organization -->
						<ng-container *ngIf="creator.creatorOrganizations[0].organization.text === creator.creatorname; else assigned">
							<!-- todo: Check if role has rights to see details of organization -->
							<span>{{creator.creatorOrganizations[0].organization.text}}</span>
						</ng-container>
						<!-- Display when organization is assigned to person -->
						<ng-template #assigned>
							<!-- todo: Check if role has rights to see details of organization -->
							<span>&ngsp;({{getCreatorOrganizations(creator.creatorOrganizations)}})</span>
						</ng-template>
					</span>

					<span *ngIf="showAsExternalOrganization(creator)">
						<!-- Check if creator is external organization -->
						<ng-container *ngIf="creator.creatorOrganizations[0].researchPartner.defaulttext === creator.creatorname; else assigned">
							<!-- todo: Check if role has rights to see details of external organization -->
							<span>{{creator.creatorOrganizations[0].researchPartner.defaulttext}}</span>
						</ng-container>
						<!-- Display when external organization is assigned to person -->
						<ng-template #assigned>
							<!-- todo: Check if role has rights to see details of organization -->
							<span>&ngsp;({{getCreatorOrganizations(creator.creatorOrganizations)}})</span>
						</ng-template>
					</span>

					<span *ngIf="showAsSomethingElse(creator)">
						<strong>{{creator.nameprefix}} {{creator.firstname}} {{creator.namesuffix}} {{creator.creatorname}}</strong>
					</span>


					<span *ngIf="!lastCreator">, </span>
					<button *ngIf="publication.creators.length - 1 === i" class="icon" (click)="showAllCreators = false">
						<img *ngIf="isTypeOfAuthor()" hisImage="ARROW_UP_V" class="inlineicon" title="{{ ('fs.res.publication.view.showLessAuthors' | hisUi) }}">
						<img *ngIf="isTypeOfEditor()" hisImage="ARROW_UP_V" class="inlineicon" title="{{ ('fs.res.publication.view.showLessEditors' | hisUi) }}">
					</button>
				</ng-container>
			</ng-container>
		</span>
	</div>
	<br />

	<!-- Publisher information -->
	<div class="publisher">
		<span *ngIf="publication.publisher">
			{{'fs.res.publication.Publisher' | hisUi}}: <strong class="textTooltip" title="{{'fs.res.publication.Publisher.place'| hisUi}}: {{publication.publisher.place}}">
            <his-translated-text [hisobject]="publication.publisher" hisAttribute="defaulttext"></his-translated-text></strong>
			&ngsp;(<span>{{'fs.res.publication.Publication.releaseYear' | hisUi}}: {{publication.releaseYear}}</span>
			<span *ngIf="publication.volume">, {{'fs.res.publication.Publication.volume' | hisUi}}: {{publication.volume}}</span>
			<span *ngIf="publication.issue">, {{'fs.res.publication.Publication.issue' | hisUi}}: {{publication.issue}}</span>
			<span *ngIf="pageRange">, {{'fs.res.publication.Publication.pageRange' | hisUi}}: {{pageRange}}</span>
            <span *ngIf="publication.articleNumber">, {{'fs.res.publication.Publication.articleNumber' | hisUi}}: {{publication.articleNumber}}</span>)
		</span>
	</div>

	<div class="line_1">
		<span *ngIf="publication.parent || publication.journal">
			{{'fs.res.publication.view.parentJournalAssignment' | hisUi}}
			<ng-container *ngIf="publication.parent">
				<a *ngIf="showParentLink; else parentRawtext" [routerLink]="['/pub/view/', publication.parent.id]"
					[queryParams]="{showBackButton: true}"
					class="firstLink"
					(click)="onBeforeNavigate()"
					title="{{ 'fs.res.publication.Publication' | hisUi }}: {{publication.parent.title}}">
					<strong>
						<span>{{publication.parent.title}}</span>
					</strong>
				</a>
				<ng-template #parentRawtext>
					<strong>
						<span>{{publication.parent.title}}</span>
					</strong>
				</ng-template>
			</ng-container>
			<ng-container *ngIf="publication.journal">
				<a *ngIf="auth.hasAll('RIGHT_FS_RES_PUBLICATION_VIEW_JOURNAL'); else journalRawtext" [routerLink]="['/pub/journal/view/', publication.journal.id]"
					class="firstLink"
                    (click)="onBeforeNavigate()"
					title="{{ 'fs.res.publication.Journal' | hisUi }}: {{publication.journal.defaulttext}}">
					<strong>
                        <his-translated-text [hisobject]="publication.journal" hisAttribute="defaulttext"></his-translated-text>
					</strong>
				</a>
				<ng-template #journalRawtext>
					<strong>
                        <his-translated-text [hisobject]="publication.journal" hisAttribute="defaulttext"></his-translated-text>
					</strong>
				</ng-template>
			</ng-container>
			&ngsp;(<span>{{'fs.res.publication.Publication.releaseYear' | hisUi}}: {{publication.releaseYear}}</span>
			<span *ngIf="publication.volume">, {{'fs.res.publication.Publication.volume' | hisUi}}: {{publication.volume}}</span>
			<span *ngIf="publication.issue">, {{'fs.res.publication.Publication.issue' | hisUi}}: {{publication.issue}}</span>
			<span *ngIf="pageRange">, {{'fs.res.publication.Publication.pageRange' | hisUi}}: {{pageRange}}</span>
            <span *ngIf="publication.articleNumber">, {{'fs.res.publication.Publication.articleNumber' | hisUi}}: {{publication.articleNumber}}</span>)
		</span>
        <div class="clearer"></div>

		<!-- TODO: Sortierung der Anzeige der Identifier, momentan Reihenfolge Anzeige = Reihenfolge Eingabeliste -->
		<div *ngIf="!isEmpty(publication.globalIdentifiers)">
			<ul class="listSimple">
				<ng-container *ngFor="let identifier of publication.globalIdentifiers; index as i" [ngSwitch]="identifier.globalIdentifierType.hiskeyId">
					<li *ngSwitchCase="identifierEnum.DOI">
						<a href="{{identifierEnum.DOI_PATH}}{{identifier.identifier}}"
							title="{{'fs.res.publication.accessByDOI' | hisUi}}">{{identifier.globalIdentifierType.text}} : {{identifier.identifier}}</a>
					</li>
					<li *ngSwitchCase="identifierEnum.URN">
						<a href="{{identifierEnum.URN_PATH}}{{identifier.identifier}}"
							title="{{'fs.res.publication.accessByURN' | hisUi}}">{{identifier.globalIdentifierType.text}} : {{identifier.identifier}}</a>
					</li>
					<li *ngSwitchCase="identifierEnum.HANDLE">
						<a href="{{identifierEnum.HANDLE_PATH}}{{identifier.identifier}}"
							title="{{'fs.res.publication.accessByHandle' | hisUi}}">{{identifier.globalIdentifierType.text}} : {{identifier.identifier}}</a>
					</li>
				</ng-container>
			</ul>
		</div>
	</div>
</div>
